import * as React from 'react'
import styled from 'styled-components'

import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { Store } from '../../../reducers/index'
import { Action } from '../../../actions/types'
import { clearJobId } from '../../../actions/calculation'
import { saveThumbnail } from '../../../actions/project'

import { BaseButton, LinkButton } from '../../Styled/Shared'
import SneakWindow from './SneakWindow'
import ResultLoader from '../../ResultData'
import Error from '../../Shared/Alerts/Error'
import { getThumbnailDataUrl } from '../../ProjectToolbar/thumbnail'

const SubmitWrapper = styled.div`
  position: relative;

  button.results-link-appear {
    bottom: -67px !important;
    background: #354b55;
  }
`

const SubmitButton = styled(BaseButton)`
  height: 56px;
  width: 320px;
  min-width: 320px;

  &:hover {
    transform: none;
  }

  border-radius: 0px;
  font-size: 20px;
  padding: 15px;
  font-weight: 600;
`

export const LinkSubmitButton = styled(LinkButton)`
  height: 56px;
  line-height: 50px;
  width: 320px;
  min-width: 320px;

  &:hover {
    transform: none;
  }

  border-radius: 0px;
  font-size: 20px;
  padding: 0px 15px;
  font-weight: 600;
`

type SubmitProps = {
  projectId: string
  caseId: string
  allValid: boolean
  jobId?: string
  handleSubmit: () => void
  clearJob: () => Action
  saveThumbnail: (thumbnailData: string) => Action
}

type SubmitPropsForm = SubmitProps

const SubmitButtonContainer: React.SFC<SubmitPropsForm> = props => {
  const saveCurrentThumbnail = () => {
    const elem = document.getElementById(
      'previz-canvas'
    ) as HTMLCanvasElement | null
    if (!elem) {
      return
    }
    props.saveThumbnail(getThumbnailDataUrl(elem))
  }

  return (
    <ResultLoader
      jobId={props.jobId}
      render={(results, numResults, error) => {
        if (!results) {
          return (
            <SubmitButton
              onClick={() => {
                props.handleSubmit()
                saveCurrentThumbnail()
                sessionStorage.setItem('isMiniatureUpdated', 'false')
                window.dispatchEvent(new Event('storage'))
              }}
              full={true}
              type="submit"
              disabled={!props.allValid}
              primary={true}
            >
              Calculate case
            </SubmitButton>
          )
        }

        const resultId =
          results && results.length > 0 ? results[0].resultId : undefined
        const done = numResults === results.length

        return (
          <SubmitWrapper>
            {error && props.jobId && (
              <Error onDismiss={props.clearJob}>{error}</Error>
            )}
            {props.jobId && (
              <SneakWindow
                error={undefined}
                results={results}
                jobId={resultId}
                resultCount={numResults}
              />
            )}
            {!done ? (
              <SubmitButton
                primary={true}
                disabled={true}
                full={true}
                type="submit"
              >
                Calculating...
              </SubmitButton>
            ) : (
              <LinkSubmitButton
                to={`/project/${props.projectId}/case/${
                  props.caseId
                }/results/${resultId}`}
              >
                Go to results
              </LinkSubmitButton>
            )}
          </SubmitWrapper>
        )
      }}
    />
  )
}

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  clearJob: () => dispatch(clearJobId()),
  saveThumbnail: (thumbnailData: string) =>
    dispatch(saveThumbnail(thumbnailData))
})

export default connect(
  null,
  mapDispatchToProps
)(SubmitButtonContainer)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/SubmitButton.tsx